import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline';
export const ChatBubbleIcon = ChatBubbleOvalLeftEllipsisIcon;
